// extracted by mini-css-extract-plugin
export default {"wrapper":"FAQ_wrapper__NNX1-"};